type Params = {
  factorLeft?: number
  factorTop?: number
  stencilAspectRatio?: number
  imageSize: {
    width: number
    height: number
  }
  visibleArea: {
    width: number
    height: number
    left: number
    top: number
  }
}

export default function calcCropperCoordinates({
  factorLeft = 0.5,
  factorTop = 0.5,
  stencilAspectRatio,
  imageSize,
  visibleArea,
}: Params) {
  let width = visibleArea.width
  let height = visibleArea.height
  let left = 0
  let top = 0

  if (stencilAspectRatio) {
    width = Math.round(
      Math.min(visibleArea.height * stencilAspectRatio, visibleArea.width)
    )
    height = Math.round(
      Math.min(visibleArea.width / stencilAspectRatio, visibleArea.height)
    )
    left = Math.round((imageSize.width - width) * factorLeft)
    top = Math.round((imageSize.height - height) * factorTop)
  } else {
    width = Math.round(Math.min(visibleArea.width, imageSize.width))
    height = Math.round(Math.min(visibleArea.height, imageSize.height))
    left = visibleArea.left > 0 ? Math.round(visibleArea.left) : 0
    top = visibleArea.top > 0 ? Math.round(visibleArea.top) : 0
  }

  top = top || 0
  left = left || 0
  height = height || 0
  width = width || 0

  return {
    left,
    top,
    width,
    height,
  }
}
